// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReceiptClaimResponse } from './IReceiptClaimResponse';
import {
    IReceiptClaimResponseFromJSON,
    IReceiptClaimResponseFromJSONTyped,
    IReceiptClaimResponseToJSON,
    IReceiptClaimResponseToJSONTyped,
} from './IReceiptClaimResponse';

/**
 * 
 * @export
 * @interface IReceiptDocumentFileResponse
 */
export interface IReceiptDocumentFileResponse {
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileResponse
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDocumentFileResponse
     */
    file_id?: number;
    /**
     * 
     * @type {Array<IReceiptClaimResponse>}
     * @memberof IReceiptDocumentFileResponse
     */
    claims: Array<IReceiptClaimResponse>;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDocumentFileResponse
     */
    document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDocumentFileResponse
     */
    receipt_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileResponse
     */
    filename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileResponse
     */
    file_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileResponse
     */
    file_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileResponse
     */
    provider_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IReceiptDocumentFileResponse
     */
    created_at?: Date;
}

/**
 * Check if a given object implements the IReceiptDocumentFileResponse interface.
 */
export function instanceOfIReceiptDocumentFileResponse(value: object): value is IReceiptDocumentFileResponse {
    if (!('claims' in value) || value['claims'] === undefined) return false;
    return true;
}

export function IReceiptDocumentFileResponseFromJSON(json: any): IReceiptDocumentFileResponse {
    return IReceiptDocumentFileResponseFromJSONTyped(json, false);
}

export function IReceiptDocumentFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReceiptDocumentFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'file_id': json['file_id'] == null ? undefined : json['file_id'],
        'claims': ((json['claims'] as Array<any>).map(IReceiptClaimResponseFromJSON)),
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'filename': json['filename'] == null ? undefined : json['filename'],
        'file_path': json['file_path'] == null ? undefined : json['file_path'],
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IReceiptDocumentFileResponseToJSON(json: any): IReceiptDocumentFileResponse {
    return IReceiptDocumentFileResponseToJSONTyped(json, false);
}

export function IReceiptDocumentFileResponseToJSONTyped(value?: IReceiptDocumentFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'file_id': value['file_id'],
        'claims': ((value['claims'] as Array<any>).map(IReceiptClaimResponseToJSON)),
        'document_id': value['document_id'],
        'receipt_id': value['receipt_id'],
        'filename': value['filename'],
        'file_path': value['file_path'],
        'file_url': value['file_url'],
        'provider_name': value['provider_name'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

